/**
 * GuestLinkField
 * Read-only "Gästlänk (om e-post inte kommer fram)" field with a copy button,
 * shown after an external invite so the admin can hand over the link when the
 * e-mail does not arrive. Lifted from the former DelegateModal.
 */
import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { Check, Copy } from 'lucide-react';

interface GuestLinkFieldProps {
    link: string;
}

const GuestLinkField: React.FC<GuestLinkFieldProps> = ({ link }) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(link);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            console.error('Failed to copy guest link:', err);
        }
    };

    return (
        <div>
            <Form.Label htmlFor="guest-link-field">Gästlänk (om e-post inte kommer fram)</Form.Label>
            <div className="d-flex gap-2">
                <Form.Control
                    id="guest-link-field"
                    type="text"
                    value={link}
                    readOnly
                    className="text-truncate"
                />
                <Button variant="outline-secondary" onClick={handleCopy} title="Kopiera länk" aria-label="Kopiera länk">
                    {copied ? <Check size={16} /> : <Copy size={16} />}
                </Button>
            </div>
            <Form.Text className="text-muted">
                Dela denna länk direkt om mottagaren inte får e-posten.
            </Form.Text>
        </div>
    );
};

export default GuestLinkField;
